import Image from 'next/image'
import { Badge } from 'ui/src/components/Badge/Badge'
import { HedvigSymbol } from 'ui/src/components/HedvigSymbol/HedvigSymbol'
import { Text } from 'ui/src/components/Text/Text'
import { xStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { tokens } from 'ui/src/theme/tokens.css'
import { badgeFontSize, card, cardLabelText, pillowBackground, pillowImage } from './Flow03Insurance.css'

export type InsuranceShowcaseCardProps = {
  title: string
  subLabel: string
  pillowSrc: string
  tier: string
  status: string
}

export function InsuranceShowcaseCard({ title, subLabel, pillowSrc, tier, status }: InsuranceShowcaseCardProps) {
  return (
    <article className={card}>
      <div className={xStack({ alignItems: 'center', justifyContent: 'space-between' })}>
        <div className={xStack({ gap: 'xxs' })}>
          <Badge variant="frosted3" size="xsmall" className={badgeFontSize}>
            {tier}
          </Badge>
          <Badge variant="frosted2" size="xsmall" className={badgeFontSize}>
            {status}
          </Badge>
        </div>
        <HedvigSymbol size="1.25rem" color={tokens.colors.text.opaque.negative} />
      </div>
      <div className={sprinkles({ mt: 'auto' })} data-theme="dark">
        <Text size={{ _: 'xxs', md: 'xs' }} color="textPrimary" className={cardLabelText}>
          {title}
        </Text>
        <Text size={{ _: 'xxs', md: 'xs' }} color="textTranslucentSecondary" className={cardLabelText}>
          {subLabel}
        </Text>
      </div>
      <div className={pillowBackground} aria-hidden="true">
        <Image loading="eager" src={pillowSrc} alt="" fill sizes="340px" className={pillowImage} />
      </div>
    </article>
  )
}
